import React, { useState } from "react";
import CommonFormLabel from "../../components/formLabel";
import Input from "../../components/input";
import { useNavigate, useLocation } from "react-router-dom";
import ValidationFeedback from "../../components/validationFeedback";
import CommonButton from "../../components/commonButton";
import FileInput from "../../components/fileInput";
import { useDispatch } from "react-redux";
import { Toast, Form, Col, Row, Card } from "react-bootstrap";
import { Formik } from "formik";
import { addPage } from "./pageSlice";
import { pageSchema } from "../../schema/validationSchemas";
import Editor from "../../components/commonEditor";

export default function Add() {
  const navigate = useNavigate();
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarVariant, setSnackbarVariant] = useState("success");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const dispatch = useDispatch();

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const currentPage = params.get("page") || 1;
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const selected_organization_id = pathSegments.length > 1 && pathSegments[0] === "organization" 
    ? pathSegments[1] 
    : null;

  const initialEventState = {
    organization_id: selected_organization_id,
    title: "",
    description: "",
    banner_image: "",
  };

  const handleModalClose = () => {
    navigate(`/organization/${selected_organization_id}/pages?page=${currentPage}`);
  };

  const handleImageChange = (file, setFieldValue) => {
    if (file) {
      setImagePreview(URL.createObjectURL(file));
      setFieldValue("banner_image", file);
    }
  };

  const handleSubmit = async (values, { setSubmitting, setErrors }) => {
    setIsSubmitting(true);
    await dispatch(addPage(values))
      .then((res) => {
        if (res.payload && res.payload.success) {
          localStorage.setItem("page_notify_message", res.payload.message);
          setSnackbarMessage(res.payload.message);
          setSnackbarVariant("success");
          setShowSnackbar(true);
          setSubmitting(false);
          setIsSubmitting(false);
          navigate(`/organization/${selected_organization_id}/pages`);
        } else {
          setErrors(res.payload.data);
          setSnackbarMessage(res.payload.message || "Failed to add page!");
          setSnackbarVariant("danger");
          setShowSnackbar(true);
          setSubmitting(false);
          setIsSubmitting(false);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setSnackbarMessage("Failed to add page!");
        setSnackbarVariant("danger");
        setShowSnackbar(true);
        setSubmitting(false);
        setIsSubmitting(false);
      });
  };

  return (
    <>
      <Toast
        onClose={() => setShowSnackbar(false)}
        show={showSnackbar}
        delay={3000}
        autohide
        bg={snackbarVariant}
        style={{ position: "fixed", top: 20, right: 20, zIndex: 1000 }}
      >
        <Toast.Body style={{ color: "white" }}>{snackbarMessage}</Toast.Body>
      </Toast>

      <Formik
        initialValues={initialEventState}
        validationSchema={pageSchema}
        onSubmit={handleSubmit}
        style={{ position: "fixed", top: 20, right: 20, zIndex: 1000 }}
      >
        {({
          errors,
          touched,
          handleChange,
          handleSubmit,
          values,
          setFieldValue,
        }) => (
          <Form onSubmit={handleSubmit} encType="multipart/form-data" className="bg-white p-4 rounded-2 shadow-sm">
            <Card className="bg-white p-4 rounded-2 shadow-sm mb-4">
            <h4 className="mb-4 d-flex justify-content-center">Basic</h4>
            <Row>
              <Col md={12} className="mb-4">
                <CommonFormLabel
                  htmlFor="title"
                  title="Page Title"
                />
                <Input
                  id="title"
                  name="title"
                  type="text"
                  placeholder="Enter Page Title"
                  onChange={handleChange}
                  className={`shadow-none ${
                    errors?.title && touched.title
                      ? "error"
                      : "correct"
                  }`}
                />
                {touched.title && errors?.title && (
                  <ValidationFeedback title={errors?.title} />
                )}
              </Col>
              <div className="mb-4">
                <CommonFormLabel
                  htmlFor="description"
                  title="Description"
                />
                <Editor
                  value={values.description}
                  onChange={(content) =>
                    setFieldValue("description", content)
                  }
                />
                {touched.description &&
                  errors?.description && (
                    <ValidationFeedback
                      title={errors?.description}
                    />
                  )}
              </div>
            </Row>
            </Card>

            <Card className="bg-white p-4 rounded-2 shadow-sm mb-4">
            <h4 className="mb-4 d-flex justify-content-center">Image</h4>
            <div className="mb-4">
              <CommonFormLabel htmlFor="banner_image" title="Upload Image" />
              <FileInput
                name="banner_image"
                onChange={(file) => handleImageChange(file, setFieldValue)}
                error={errors?.banner_image}
                touched={touched.banner_image}
              />
              {touched.banner_image && errors?.banner_image && (
                <ValidationFeedback title={errors?.banner_image} />
              )}
              {imagePreview && (
                  <div className="mt-3">
                    <img
                      src={imagePreview}
                      alt="Blog Preview"
                      style={{
                        width: "200px",
                        height: "auto",
                        border: "1px solid #ddd",
                        borderRadius: "5px",
                      }}
                    />
                  </div>
                )}
            </div>
            </Card>

            <div className="d-flex align-items-center justify-content-end gap-3 common-popup-btn">
              <CommonButton
                title={isSubmitting ? "Adding..." : "Add"}
                type="submit"
                disabled={isSubmitting}
                className="btn-primary primary-shadow"
              />
              <CommonButton
                title="Cancel"
                onClick={handleModalClose}
                className="btn-muted"
              />
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
}
